jQuery(document).ready(function () {
  // Initialize custom shuffle
  charlInitCustomShuffle();
});

/**
 * Initialize custom shuffle for elements with .custom-shuffle class
 * Randomizes children with .shuffle-item class using CSS flexbox order property
 * Preserves .no-shuffle items in their original positions (first or last)
 */
/*function charlInitCustomShuffle() {
  jQuery(".custom-shuffle").each(function () {
    const $container = jQuery(this);
    const $items = $container.find(".shuffle-item");
    const $noShuffleItems = $items.filter(".no-shuffle");
    const $shuffleItems = $items.not(".no-shuffle");

    // Track positions of no-shuffle items
    let firstIsNoShuffle = false;
    let lastIsNoShuffle = false;

    if ($noShuffleItems.length > 0) {
      const firstItem = $items.first();
      const lastItem = $items.last();

      firstIsNoShuffle = firstItem.hasClass("no-shuffle");
      lastIsNoShuffle = lastItem.hasClass("no-shuffle");
    }

    // Calculate order range for shuffleable items
    const totalItems = $items.length;
    let startOrder = firstIsNoShuffle ? 2 : 1;
    let endOrder = lastIsNoShuffle ? totalItems - 1 : totalItems;

    // Set fixed order for no-shuffle items
    if (firstIsNoShuffle) {
      $items.first().css("order", 1);
    }
    if (lastIsNoShuffle) {
      $items.last().css("order", totalItems);
    }

    // Generate random orders for shuffleable items
    const availableOrders = [];
    for (let i = startOrder; i <= endOrder; i++) {
      availableOrders.push(i);
    }

    // Shuffle for available orders
    for (let i = availableOrders.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [availableOrders[i], availableOrders[j]] = [
        availableOrders[j],
        availableOrders[i],
      ];
    }

    // Apply random orders to shuffleable items
    $shuffleItems.each(function (index) {
      jQuery(this).css("order", availableOrders[index]);
    });

    let isPartiallyVisible = jQuery(this).data(
      "shuffle-partially-visible-amount"
    );

    // Handle partial visibility if specified
    if (
      typeof isPartiallyVisible !== "undefined" &&
      !isNaN(isPartiallyVisible) &&
      Number.isInteger(Number(isPartiallyVisible))
    ) {
      // Show only the specified number of shuffle items
      // Select random shuffle items to be visible
      const totalShuffleItems = $shuffleItems.length;

      // Generate array of indexes and shuffle it
      const indexes = Array.from({ length: totalShuffleItems }, (_, i) => i);
      for (let i = indexes.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [indexes[i], indexes[j]] = [indexes[j], indexes[i]];
      }

      // Pick first N indexes for visibility
      const selectedIndexes = indexes.slice(0, isPartiallyVisible);

      $shuffleItems.each(function (index) {
        if (selectedIndexes.includes(index)) {
          jQuery(this).addClass("partially-visible");
        } else {
          jQuery(this).addClass("partially-hidden");
        }
      });
    }
  });
}*/
function charlInitCustomShuffle() {
  jQuery(".custom-shuffle").each(function () {
    const $container = jQuery(this);
    const $items = $container.find(".shuffle-item");
    const $noShuffleItems = $items.filter(".no-shuffle");
    const $shuffleItems = $items.not(".no-shuffle");

    // Track positions of no-shuffle items
    let firstIsNoShuffle = false;
    let lastIsNoShuffle = false;

    if ($noShuffleItems.length > 0) {
      const firstItem = $items.first();
      const lastItem = $items.last();

      firstIsNoShuffle = firstItem.hasClass("no-shuffle");
      lastIsNoShuffle = lastItem.hasClass("no-shuffle");
    }

    // Calculate order range for shuffleable items
    const totalItems = $items.length;
    let startOrder = firstIsNoShuffle ? 2 : 1;
    let endOrder = lastIsNoShuffle ? totalItems - 1 : totalItems;

    // Set fixed order for no-shuffle items
    if (firstIsNoShuffle) {
      $items.first().css("order", 1);
    }
    if (lastIsNoShuffle) {
      $items.last().css("order", totalItems);
    }

    // Generate random orders for shuffleable items
    const availableOrders = [];
    for (let i = startOrder; i <= endOrder; i++) {
      availableOrders.push(i);
    }

    // Shuffle for available orders
    for (let i = availableOrders.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [availableOrders[i], availableOrders[j]] = [
        availableOrders[j],
        availableOrders[i],
      ];
    }

    // Apply random orders to shuffleable items
    $shuffleItems.each(function (index) {
      jQuery(this).css("order", availableOrders[index]);
    });

    let isPartiallyVisible = jQuery(this).data(
      "shuffle-partially-visible-amount"
    );

    // Handle partial visibility if specified
    if (
      typeof isPartiallyVisible !== "undefined" &&
      !isNaN(isPartiallyVisible) &&
      Number.isInteger(Number(isPartiallyVisible))
    ) {
      // Show only the specified number of shuffle items
      // Select random shuffle items to be visible
      const totalShuffleItems = $shuffleItems.length;

      // Generate array of indexes and shuffle it
      const indexes = Array.from({ length: totalShuffleItems }, (_, i) => i);
      for (let i = indexes.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [indexes[i], indexes[j]] = [indexes[j], indexes[i]];
      }

      // Pick first N indexes for visibility
      const selectedIndexes = indexes.slice(0, isPartiallyVisible);

      $shuffleItems.each(function (index) {
        if (selectedIndexes.includes(index)) {
          jQuery(this).addClass("partially-visible");
        } else {
          jQuery(this).addClass("partially-hidden");
        }
      });
    }
  });}


